





















import Vue from 'vue'
import { Component, Prop, VModel } from 'vue-property-decorator'

import { UserInfo } from '../../../../../../../../../../models/getUserInfo/GetUserInfo'
import CustomEditor from '../../../../../../Editor/CustomEditor'
import UsersInfoHelper from '../../../../../../Helpers/UserInfoHelper'
import UserInfoHelper from '../../../../../../Helpers/UserInfoHelper'
import ConstantValue
  from '../../../../../Branching/ConditionsNode/logic/PropertyConditionValues/ConstantValue'
import NotifyUsersActionAddUserField
  from '../../../../../Communications/Action/ui/sidebar/Actions/NotifyUsersAction/components/NotifyUsersActionAddUserField.vue'
import NotifyUsersActionTable
  from '../../../../../Communications/Action/ui/sidebar/Actions/NotifyUsersAction/components/NotifyUsersActionTable.vue'
import { RunFlowNodeProps } from '../../../logic/types'

@Component({
  components: {
    NotifyUsersActionTable,
    NotifyUsersActionAddUserField
  }
})
export default class ConstantTargetValue extends Vue {
  @Prop() editor!: CustomEditor

  @Prop({ type: Function, default: () => () => [] }) usersOptions!: RunFlowNodeProps['usersOptions']

  @VModel() target!: ConstantValue

  isLoading = false

  get users(): Array<UserInfo> {
    const result: Array<UserInfo> = []

    if (this.target.value) {
      const info = UsersInfoHelper.getUser(this.target.value)

      if (info) {
        result.push(info)
      }
    }

    return result
  }

  onAdd(id: number) {
    this.addUser(id, false)
  }

  onAddToNotFound(id: number) {
    this.addUser(id, true)
  }

  addUser(id: number | string, isError: boolean) {
    const user = UserInfoHelper.getUser(id)

    if (user) {
      this.users.splice(0, 1, {
        ...user,
        ...isError ? {
          error: this.$t('flow_get_user_info_user_not_found').toString()
        } : {}
      })

      if (user?.info) {
        this.target.value = user.info.id
      }

    }
  }

}
